// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3506":"a69d3618","9417":"b2197055"}[chunkId] + ".chunk.css";
};